import { Components } from 'src/components';
import { setComponentAttributes, createStoryWrapper } from 'shared/storybook-utils';

export default {
  title: 'Components/Message',
  component: 'a1-message',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Partial Component - Notification Message for the user',
      },
    },
    layout: 'centered',
  },
  decorators: [createStoryWrapper({ height: 40 })],
};

const elementName = 'a1-message';

const Template = (args: Components.A1Message): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Critical: Story<Components.A1Message> = Template.bind({});
Critical.args = {
  type: 'critical',
  text: 'This is a critical message.',
};

export const Warning: Story<Components.A1Message> = Template.bind({});
Warning.args = {
  type: 'warning',
  text: 'This is a warning message.',
};

export const Positive: Story<Components.A1Message> = Template.bind({});
Positive.args = {
  type: 'positive',
  text: 'This is a positive message.',
};

export const Info: Story<Components.A1Message> = Template.bind({});
Info.args = {
  type: 'info',
  text: 'This is an info message.',
};
